import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userLogin } from 'admin-on-rest';
import Logo from '../../images/logo.png';
import {exists} from "../../../util/util";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Snackbar from 'material-ui/Snackbar';


class LoginForm extends Component {
  
  constructor() {
    super();
    
    this.state = {
      username: '',
      password: '',
      errorNotificationOpen: null
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if(exists(nextProps.user.loginSuccess))
      this.setState({ errorNotificationOpen: nextProps.user.loginSuccess });
  }
  
  render() {
    return(
      <div className="login-form">
        <div className="logo">
          <img src={Logo} alt="logo" className="center-element" />
        </div>
        <h2 className="title">Pampett</h2>
        <div className="form-wrapper">
          <form onSubmit={e => this._onSubmitLogIn(e)}>
            <div className="field-wrapper">
              <input
                type="text"
                className="field"
                placeholder="email"
                name="username"
                value={this.state.username}
                onChange={e => this._onInputChange(e)} />
              <span className="error-message" />
            </div>
            <div className="field-wrapper">
              <input
                type="password"
                className="field"
                placeholder="password"
                name="password"
                value={this.state.password}
                onChange={e => this._onInputChange(e)} />
              <span className="error-message" />
            </div>
            <button type="button" className="toRegisterForm link-button" onClick={() => this._showRegisterForm()}>Register</button>
            <br />
            <button type="submit" className="loginBtn submit-button">Log in</button>
          </form>
        </div>
        {this._renderLoginErrorNotification()}
      </div>
    );
  }
  
  _renderLoginErrorNotification() {
    
    let open = !!(exists(this.state.errorNotificationOpen) && !this.state.errorNotificationOpen);
    
    return(
      <MuiThemeProvider>
        <Snackbar
          open={open}
          message="Incorrect username or password"
          autoHideDuration={4000}
          onRequestClose={() => this._loginNotificationClose()}
          bodyStyle={{ background: "#ff4081" }}
        />
      </MuiThemeProvider>
    );
  }
  
  _onSubmitLogIn(event) {
    event.preventDefault();
    
    let username = this.state.username.trim();
    let password = this.state.password.trim();
    
    this.props.userLogin({ username, password });
  }
  
  _onInputChange(event) {
    let { name, value } = event.target;
    this.setState({ [name]: value });
  }
  
  _showRegisterForm() {
    if(this.props.showRegisterForm)
      this.props.showRegisterForm();
  }
  
  _loginNotificationClose() {
    this.setState({ errorNotificationOpen: null });
  }
}

const mapStateToProps = state => ({
  user: state.rootReducer.user
});

export default connect(mapStateToProps, {
  userLogin
})(LoginForm);


// WEBPACK FOOTER //
// ./src/common/components/LoginForm/LoginForm.js